module.exports = __webpack_public_path__ + "img/del.aa92279e.svg";